module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_06_12_us_orlando-nightclub-shooting_index.html_plot.1ae1a05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_06_12_us_orlando-nightclub-shooting_index.html_plot.png
// module id = 370
// module chunks = 0